import React from 'react'

import CareerPlaceList from './careerplacelist'
import CareerPlaceCard from './careerplacecard'

export default (props) => (
  <div className="career__box box tile">
    <CareerPlaceList
      currentPlace={props.currentPlace}
      onSwitchPlace={props.setCurrentPlace}
      data={props.data} />
    <CareerPlaceCard
      currentPlace={props.currentPlace} />
  </div>
)
